import { atomWithReset } from 'jotai/utils';

import { LiveConsultation } from '../model/live-consultation';

export const closedLiveConsultationAtom =
  atomWithReset<LiveConsultation.Level2 | null>(null);
closedLiveConsultationAtom.debugLabel = 'closedLiveConsultationAtom';
